const expertManagement = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/expertManagement.vue')),
    'expertManagement'
  );
const expertIndex = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/expert/expertIndex.vue')),
    'expertIndex'
  );
const expertReview = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/expertReview.vue')),
    'expertReview'
  );
const expertReviewzj = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/expertReviewzj.vue')),
    'expertReviewzj'
  );
const infoChangeExamine = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/infoChangeExamine.vue')),
    'infoChangeExamine'
  );
const examinelistView = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/companyInfoConfirm/companyInfoConfirmView')),
    'companyInfoConfirmView'
  );
const exam = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/exam.vue')),
    'exam'
  );
const appointment = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/appointment.vue')),
    'appointment'
  );
const applyExpertInfo = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/applyExpertInfo.vue')),
    'applyExpertInfo'
  );

  const testScores = (r) =>
    require.ensure(
      [],
      () => r(require('@/page/experDabase/apply/testScores.vue')),
      'testScores'
    );
  

const goodInformationInput = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/goodInformation/input.vue')),
    'goodInformationInput'
  );
  const goodInformationCheck = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/goodInformation/input.vue')),
    'goodInformationInput'
  );
  const goodmanage = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/goodInformation/goodmanage.vue')),
    'goodmanage'
  );
  const goodInformationAccept = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/goodInformation/input.vue')),
    'goodInformationAccept'
  );
  const goodInformationReviewCancel = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/goodInformation/input.vue')),
    'goodInformationReviewCancel'
  );
  const goodInformationReviewSee = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/goodInformation/input.vue')),
    '  goodInformationReviewSee'
  );
  const goodInformationUnDoReturn = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/goodInformation/input.vue')),
    'goodInformationUnDoReturn'
  );
  const applyExpertInfoForGw = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/applyExpertInfoForGw.vue')),
    'applyExpertInfoForGw'
  );
const certificateViewing = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/certificateViewing.vue')),
    'certificateViewing'
  );
const expertApplicationRecord = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/expertApplicationRecord.vue')),
    'expertApplicationRecord'
  );
const expertApplicationTexrRecord = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/experDabase/apply/expertApplicationTexrRecord.vue')),
    'expertApplicationTexrRecord'
  );
const expertApplicationTexrRecordGw = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/experDabase/apply/expertApplicationTexrRecordGw.vue')),
    'expertApplicationTexrRecordGw'
  );
const expertApplicationTexrRecordGwList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/experDabase/apply/expertApplicationTexrRecordGwList.vue')
      ),
    'expertApplicationTexrRecordGwList'
  );
const expertApplyRouterIndex = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/expertApplyRouterIndex.vue')),
    'expertApplyRouterIndex'
  );
const expertApplicationTextReviewRecord = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/experDabase/apply/expertApplicationTextReviewRecord.vue')
      ),
    'expertApplicationTextReviewRecord'
  );
const expertApplicationTexrApplyRecord = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/experDabase/apply/expertApplicationTexrApplyRecord.vue')
      ),
    'expertApplicationTexrApplyRecord'
  );
const electronicArchives = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/expert/electronicArchives.vue')),
    'electronicArchives'
  );
const myElectronicArchives = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/expert/myElectronicArchives.vue')),
    'myElectronicArchives'
  );
const performanceEvaluationDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/experDabase/expert/performanceEvaluationDetails.vue')),
    'performanceEvaluationDetails'
  );
const expertInfoChange = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/expertInfoChange.vue')),
    'expertInfoChange'
  );
const auditItemQuery = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/auditItemQuery.vue')),
    'auditItemQuery'
  );
const auditQuery = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/auditQuery.vue')),
    'auditQuery'
  );
const checkExpertList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/examine/checkExpertList.vue')),
    'checkExpertList'
  );


const freeExamList = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/apply/freeExamList.vue')),
  'freeExamList'
);

// 发证名单
const expertCertificationList = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/apply/expertCertificationList.vue')),
  'expertCertificationList'
);

// 查看不合格名单
const lookUnqualifiedList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/apply/lookUnqualifiedList.vue')),
    'lookUnqualifiedList'
  );

//申请请假暂停
const declareSuspend = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/declareSuspend/declareSuspend.vue')),
  'declareSuspend'
);

//请假暂停查看
const declareSusApplyDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/declareSuspend/declareSuspend.vue')),
  'declareSusApplyDetail'
);

//请假暂停审核
const declareSuspendCheck = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/declareSuspend/declareSuspend.vue')),
  'declareSuspendCheck'
);

//请假暂停审核查看
const declareSusCheckDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/declareSuspend/declareSuspend.vue')),
  'declareSusCheckDetail'
);

//暂停评标----开始
//暂停评标详情
const suspendBidEvaluation = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidEvaluation'
);
//暂停评标撤销
const suspendBidRevoke = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidRevoke'
);
//暂停评标录入
const suspendBidInput = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidInput'
);
//暂停评标审核
const suspendBidCheck = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidCheck'
);

//暂停评标审核查看
const suspendBidCheckView = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidCheckView'
);

//暂停评标撤销审核
const suspendBidRevokeCheck = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidRevokeCheck'
);

//暂停评标撤销审核查看
const suspendBidRevokeCheckView = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidRevokeCheckView'
);

//暂停评标业务单关联查看
const suspendBidAssociaView = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidAssociaView'
);


//暂停评标撤销业务单关联查看
const suspendBidAssociaRevokeView = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidEvaluation/suspendBidEvaluation.vue')),
  'suspendBidAssociaRevokeView'
);
//暂停评标----结束
const dismissalOutbound = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/dismissalOutbound/dismissalOutbound.vue')),
  'dismissalOutbound'
);

const suspendBidList = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/suspendBidMge/suspendBidList.vue')),
  'suspendBidList'
);

const dismissalOutList = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/dismissalOutMge/dismissalList.vue')),
  'dismissalOutList'
);
const withdrawManagement = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/expert/withdrawManagement/withdrawManagement.vue')),
  'withdrawManagement'
);
const badBehaviorList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/badBehavior/badBehaviorList.vue')),
    'badBehaviorList'
  );

//不良行为详情
const badBehaviorDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/badBehavior/badBehaviorDetail.vue')),
  'badBehaviorDetail'
);

//不良行为撤销详情
const badBehaviorRevokeDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/badBehavior/badBehaviorDetail.vue')),
  'badBehaviorRevokeDetail'
);

//不良行为认定审核查看
const badBehaviorCheckDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/badBehavior/badBehaviorDetail.vue')),
  'badBehaviorCheckDetail'
);

//不良行为撤销审核查看
const badRevokeCheckDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/badBehavior/badBehaviorDetail.vue')),
  'badRevokeCheckDetail'
);

//不良行为撤销审核
const badRevokeCheck = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/badBehavior/badBehaviorDetail.vue')),
  'badRevokeCheck'
);

//不良行为撤销
const badBehaviorRevoke = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/badBehavior/badBehaviorDetail.vue')),
  'badBehaviorRevoke'
);

//不良行为审核
const badBehaviorCheck = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/badBehavior/badBehaviorDetail.vue')),
    'badBehaviorCheck'
  );

//评审专家不良行为录入
const evaluationBadBehavior = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/badBehavior/evaluationBadBehavior.vue')),
  'evaluationBadBehavior'
);

//解聘
const dismissApply = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/dismiss/dismissApply.vue')),
  'dismissApply'
);

//专家工作记录管理
const workRecordIndex = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/workRecord/workRecordIndex.vue')),
  'workRecordIndex'
);

//评审专家工作记录
const expertWorkRecord = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/workRecord/workRecordList.vue')),
  'expertWorkRecord'
);

const workRecordDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/workRecord/workRecoedDetail.vue')),
  'workRecordDetail'
);

//评审专家定期审核
const regularReviewList = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/regularReview/regularReviewList.vue')),
  'regularReviewList'
);

const regularReviewDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/regularReview/regularReviewDetail.vue')),
  'regularReviewDetail'
);

//社会反馈信息 
const socialFeedBackList = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/socialFeedBack/socialFeedBackList.vue')),
  'socialFeedBackList'
);

const socialFeedBackDetail = (r) =>
require.ensure(
  [],
  () => r(require('@/page/experDabase/socialFeedBack/socialFeedBackDetail.vue')),
  'socialFeedBackDetail'
);
// 评标专家反馈调查表
const feedbackSurveyList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/bidFeedbackSurvey/feedbackSurveyList.vue')),
    'feedbackSurveyList'
  );
// 评标专家反馈调查表名单
const feedbackSurveyPersonList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/bidFeedbackSurvey/feedbackSurveyPersonList.vue')),
    'feedbackSurveyPersonList'
  );
// 评标专家反馈调查表详情
const feedbackSurveyDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/experDabase/bidFeedbackSurvey/feedbackSurveyDetails.vue')),
    'feedbackSurveyDetails'
  );
const examinelistRouter = {
  path: '',
  name: '专家管理',
  component: examinelistView,
  meta: {
    right: [],
    isShowMenu: true,
    icon: 'organMge',
  },
  children: [
    {
      path: '/expertIndex',
      component: expertIndex,
      name: '专家管理',
      meta: {
        right: [],
        name: '专家管理',
        isShowMenu: true,
        keepAlive: true,
        t:Date.now()
      },
    },
    {
      path: '/expertManagement',
      component: expertManagement,
      name: '专家管理',
      meta: {
        right: [],
        name: '专家管理',
        isShowMenu: true,
        keepAlive: true,
        t:Date.now()
      },
    },
    {
      path: '/exam',
      component: exam,
      name: '考试答题',
      meta: {
        right: [],
        name: '考试答题',
        isShowMenu: true,
        keepAlive: false,
        t:Date.now()
      },
    },
    {
      path: '/appointment',
      component: appointment,
      name: '电子聘书',
      meta: {
        right: [],
        name: '电子聘书',
        isShowMenu: true,
        keepAlive: false,
        t:Date.now()
      },
    },
    {
      path: '/expertReview',
      component: expertReview,
      name: '专家聘用入库',
      meta: {
        right: [],
        isShowMenu: true,
        name: '专家聘用入库',
        t:Date.now(),
        keepAlive: false,
      },
    },
    {
      path: '/expertReviewzj',
      component: expertReviewzj,
      name: '专家聘用入库',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive: false,
        name: '专家聘用入库',
        t:Date.now()
      },
    },
    {
      path: '/expertApplicationTextReviewRecord',
      component: expertApplicationTextReviewRecord,
      name: '查看考试名单',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive: false,
        name: '查看考试名单',
        t:Date.now()
      },
    },
    {
      path: '/expertApplicationTexrApplyRecord',
      component: expertApplicationTexrApplyRecord,
      name: '拟入库人员名单预览 ',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive: false,
        name: '拟入库人员名单预览 ',
        t:Date.now()
      },
    },
    {
      path: '/expertApplicationTexrApplyRecordSD',
      component: expertApplicationTexrApplyRecord,
      name: '入库审定人员名单预览 ',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive: false,
        name: '入库审定人员名单预览 ',
        t:Date.now()
      },
    },
    {
      path: '/infoChangeExamine',
      component: infoChangeExamine,
      name: '信息变更',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive: false,
        name: '信息变更',
        t:Date.now()
      },
    },
    {
      path: '/infoChangeExamine2',
      component: infoChangeExamine,
      name: '申请记录',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive: false,
        name: '申请记录',
        t:Date.now()
      },
    },
    {
      path: '/applyExpertInfo',
      component: applyExpertInfo,
      name: '评标评审专家申报',
      meta: {
        right: [],
        name: '评标评审专家申报',
        isShowMenu: true,
        keepAlive:true,
        t:Date.now()
      },
    },
    
    {
      path: '/testScores',
      component: testScores,
      name: '考试成绩查询',
      meta: {
        right: [],
        name: '考试成绩查询',
        isShowMenu: true,
        keepAlive:true,
        t:Date.now()
      },
    },
    {
      path: '/applyExpertInfo2',
      component: applyExpertInfo,
      name: '顾问专家资料提交',
      meta: {
        right: [],
        name: '顾问专家资料提交',
        isShowMenu: true,
        keepAlive:true,
        t:Date.now()
      },
    },
    {
      path: '/expertApplicationTexrRecordGwList',
      component: expertApplicationTexrRecordGwList,
      name: '查看名单',
      meta: {
        right: [],
        name: '查看名单',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/certificateViewing',
      component: certificateViewing,
      name: '资格证书查看',
      meta: {
        right: [],
        name: '资格证书查看',
        isShowMenu: true,
        t:Date.now()
      },
    },
    {
      path: '/expertApplicationRecord',
      component: expertApplicationRecord,
      name: '草稿箱',
      meta: {
        right: [],
        name: '草稿箱',
        isShowMenu: true,
        keepAlive:false,
        t:Date.now()
      },
    },
    {
      path: '/expertApplicationRecord2',
      component: expertApplicationRecord,
      name: '申请记录',
      meta: {
        right: [],
        name: '申请记录',
        isShowMenu: true,
        keepAlive:false,
        t:Date.now()
      },
    },
    {
      path: '/expertInfoChange',
      component: expertInfoChange,
      name: '信息变更',
      meta: {
        right: [],
        name: '信息变更',
        isShowMenu: true,
        t:Date.now()
      },
    },
    {
      path: '/electronicArchives',
      component: electronicArchives,
      name: '我的电子档案',
      meta: {
        right: [],
        name: '我的电子档案',
        keepAlive: false,
        isShowMenu: true,
        t:Date.now()
      },
    },
    
    {
      path: '/myElectronicArchives',
      component: myElectronicArchives,
      name: '我的电子档案',
      meta: {
        right: [],
        name: '我的电子档案',
        keepAlive: false,
        isShowMenu: true,
        t:Date.now()
      },
    },
    {
      path: '/performanceEvaluationDetails',
      component: performanceEvaluationDetails,
      name: '履职评价详情',
      meta: {
        right: [],
        name: '履职评价详情',
        isShowMenu: true,
        t:Date.now()
      },
    },
    
    // {
    //   path: '/applyExpertInfo',
    //   component: applyExpertInfo,
    //   name: '顾问专家申报',
    //   meta: {
    //     right: [],
    //     name: '顾问专家申报',
    //     isShowMenu: true,
    //     iszj:true
    //   },
    // },



    // {
    //   path: '/applyExpertInfoForGw',
    //   component: applyExpertInfoForGw,
    //   name: '顾问专家资料提交录入',
    //   meta: {
    //     right: [],
    //     name: '顾问专家资料提交录入',
    //     isShowMenu: true,
    //     isly: true,
    //     t:Date.now()
    //   },
    // },



    {
      path: '/goodInformationInput',
      component: goodInformationInput,
      name: '申报良好信息',
      meta: {
        right: [],
        name: '申报良好信息',
        isShowMenu: false,
        isly: false,
        t:Date.now()
      },
    },
    {
      path: '/goodInformationCheck',
      component: goodInformationCheck,
      name: '良好行为认定查看',
      meta: {
        right: [],
        name: '良好行为认定查看',
        isShowMenu: false,
        isly: false,
        t:Date.now()
      },
    },

    {
      path: '/goodInformationAccept',
      component: goodInformationAccept,
      name: '良好行为认定',
      meta: {
        right: [],
        name: '良好行为认定',
        isShowMenu: false,
        isly: false,
        t:Date.now()
      },
    },
    {
      path: '/goodInformationReviewCancel',
      component: goodInformationReviewCancel,
      name: '良好行为撤销审核',
      meta: {
        right: [],
        name: '良好行为撤销审核查看',
        isShowMenu: false,
        isly: false,
        t:Date.now()
      },
    },
    {
      path: '/goodInformationReviewSee',
      component: goodInformationReviewSee,
      name: '良好行为撤销',
      meta: {
        right: [],
        name: '良好行为撤销',
        isShowMenu: false,
        isly: false,
        t:Date.now()
      },
    },
    {
      path: '/goodInformationUnDoReturn',
      component: goodInformationUnDoReturn,
      name: '良好行为撤销补充材料',
      meta: {
        right: [],
        name: '良好行为撤销审核查看',
        isShowMenu: false,
        isly: false,
        t:Date.now()
      },
    },
    {
      path: '/goodInformationCheck',
      component: goodInformationInput,
      name: '良好行为详情',
      meta: {
        right: [],
        name: '申报良好信息',
        isShowMenu: false,
        isly: false,
        t:Date.now()
      },
    },
    {
      path: '/freeExamList',
      component: freeExamList,
      name: '查看免考名单',
      meta: {
        right: [],
        name: '查看免考名单',
        isShowMenu: false,
        isly: true,
        t:Date.now()
      },
    },
    {
      path: '/expertCertificationList',
      component: expertCertificationList,
      name: '发证名单',
      meta: {
        right: [],
        name: '发证名单',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/lookUnqualifiedList',
      component: lookUnqualifiedList,
      name: '查看不合格名单',
      meta: {
        right: [],
        name: '查看不合格名单',
        isShowMenu: false,
        t:Date.now()
      },
    },

    {
      path: '/expertApplyRouterIndex',
      component: expertApplyRouterIndex,
      name: '专家入库',
      meta: {
        right: [],
        name: '专家入库',
        isShowMenu: true,
        iszj: true,
        t:Date.now()
      },
      children: [
        {
          path: '/expertApplicationTexrRecord',
          component: expertApplicationTexrRecord,
          name: '评标评审专家入库管理',
          meta: {
            right: [],
            name: '评标评审专家入库管理',
            keepAlive: false,
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/expertApplicationTexrRecordGw',
          component: expertApplicationTexrRecordGw,
          name: '顾问专家入库管理',
          meta: {
            right: [],
            name: '顾问专家入库管理',
            keepAlive: false,
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
      ],
    },

    {
      path: '/expertApplyRouterIndex',
      component: expertApplyRouterIndex,
      name: '专家申报',
      meta: {
        right: [],
        name: '专家申报',
        isShowMenu: true,
        isly: true,
        t:Date.now()
      },
      children: [
        {
          path: '/applyExpertInfoForGw',
          component: applyExpertInfoForGw,
          name: '顾问专家资料提交录入',
          meta: {
            right: [],
            name: '顾问专家资料提交录入',
            isShowMenu: true,
            isly: true,
            t:Date.now()
          },
        },
        
      ],
    },

    {
      path: '/expertApplyRouterIndex',
      component: expertApplyRouterIndex,
      name: '专家审核',
      meta: {
        right: [],
        name: '专家审核',
        isShowMenu: true,
        iszj: true,
        t:Date.now()
      },
      children: [
        {
          path: '/auditItemQuery',
          component: auditItemQuery,
          name: '审核列表',
          meta: {
            right: [],
            name: '审核列表',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/auditQuery',
          component: auditQuery,
          name: '审核事项查询',
          meta: {
            right: [],
            name: '审核事项查询',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
      ],
    },
    {
      path: '/checkExpertList',
      component: checkExpertList,
      name: '专家库',
      meta: {
        right: [],
        name: '专家库',
        isShowMenu: true,
        iszj: true,
        t:Date.now()
      },
    },

    {
      path: '/expertApplyRouterIndex',
      component: expertApplyRouterIndex,
      name: '信息管理',
      meta: {
        right: [],
        name: '信息管理',
        isShowMenu: true,
        iszj: true,
        t:Date.now()
      },
      children: [
        {
          path: '/goodmanage',
          component: goodmanage,
          name: '良好行为信息管理',
          meta: {
            right: [],
            name: '良好行为信息管理',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/badBehaviorList',
          component: badBehaviorList,
          name: '不良行为信息管理',
          meta: {
            right: [],
            name: '不良行为信息管理',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/suspendBidList',
          component: suspendBidList,
          name: '暂停评标信息管理',
          meta: {
            right: [],
            name: '暂停评标信息管理',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/dismissalOutList',
          component: dismissalOutList,
          name: '解聘与出库信息管理',
          meta: {
            right: [],
            name: '解聘与出库信息管理',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/withdrawManagement',
          component: withdrawManagement,
          name: '撤销信息管理',
          meta: {
            right: [],
            name: '撤销信息管理',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
      ],
    },
    {
      path: '/declareSuspend',
      component: declareSuspend,
      name: '申请暂停',
      meta: {
        right: [],
        name: '申请暂停',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/declareSusApplyDetail',
      component: declareSusApplyDetail,
      name: '请假暂停查看',
      meta: {
        right: [],
        name: '请假暂停查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/declareSuspendCheck',
      component: declareSuspendCheck,
      name: '请假暂停审核',
      meta: {
        right: [],
        name: '请假暂停审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/declareSusCheckDetail',
      component: declareSusCheckDetail,
      name: '请假暂停审核查看',
      meta: {
        right: [],
        name: '请假暂停审核查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidEvaluation',
      component: suspendBidEvaluation,
      name: '暂停评标详情',
      meta: {
        right: [],
        name: '暂停评标详情',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidRevoke',
      component: suspendBidRevoke,
      name: '暂停评标撤销',
      meta: {
        right: [],
        name: '暂停评标撤销',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidInput',
      component: suspendBidInput,
      name: '暂停评标录入',
      meta: {
        right: [],
        name: '暂停评标录入',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidCheck',
      component: suspendBidCheck,
      name: '暂停评标审核',
      meta: {
        right: [],
        name: '暂停评标审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidCheckView',
      component: suspendBidCheckView,
      name: '暂停评标审核查看',
      meta: {
        right: [],
        name: '暂停评标审核查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidRevokeCheck',
      component: suspendBidRevokeCheck,
      name: '暂停评标撤销审核',
      meta: {
        right: [],
        name: '暂停评标撤销审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidRevokeCheckView',
      component: suspendBidRevokeCheckView,
      name: '暂停评标撤销审核查看',
      meta: {
        right: [],
        name: '暂停评标撤销审核查看',
        isShowMenu: false,
        t:Date.now()
      },
    }, 
    {
      path: '/suspendBidAssociaView',
      component: suspendBidAssociaView,
      name: '暂停评标审核查看',
      meta: {
        right: [],
        name: '暂停评标审核查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/suspendBidAssociaRevokeView',
      component: suspendBidAssociaRevokeView,
      name: '暂停评标撤销审核查看',
      meta: {
        right: [],
        name: '暂停评标撤销审核查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissalOutbound',
      component: dismissalOutbound,
      name: '解聘出库录入',
      meta: {
        right: [],
        name: '解聘出库录入',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissalOutboundSee',
      component: dismissalOutbound,
      name: '解聘出库查看',
      meta: {
        right: [],
        name: '解聘出库查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissalOutboundSeeJY',
      component: dismissalOutbound,
      name: '解聘出库',
      meta: {
        right: [],
        name: '解聘出库查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissalOutboundSL',
      component: dismissalOutbound,
      name: '解聘出库受理',
      meta: {
        right: [],
        name: '解聘出库受理',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissalOutboundRevoke',
      component: dismissalOutbound,
      name: '解聘出库撤销',
      meta: {
        right: [],
        name: '解聘出库撤销',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissalOutboundRevokeJY',
      component: dismissalOutbound,
      name: '解聘出库撤销查看',
      meta: {
        right: [],
        name: '解聘出库撤销',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissalOutboundReview',
      component: dismissalOutbound,
      name: '解聘出库审核',
      meta: {
        right: [],
        name: '解聘出库审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/goodmanageLook',
      component: goodmanage,
      name: '良好行为查看',
      meta: {
        right: [],
        name: '良好行为查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    
    {
      path: '/badBehaviorListLook',
      component: badBehaviorList,
      name: '不良行为查看',
      meta: {
        right: [],
        name: '不良行为查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/badBehaviorDetail',
      component: badBehaviorDetail,
      name: '不良行为详情',
      meta: {
        right: [],
        name: '不良行为详情',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/badBehaviorCheckDetail',
      component: badBehaviorCheckDetail,
      name: '不良行为认定审核查看',
      meta: {
        right: [],
        name: '不良行为认定审核查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/badRevokeCheckDetail',
      component: badRevokeCheckDetail,
      name: '不良行为撤销审核查看',
      meta: {
        right: [],
        name: '不良行为撤销审核查看',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/badRevokeCheck',
      component: badRevokeCheck,
      name: '不良行为撤销审核',
      meta: {
        right: [],
        name: '不良行为撤销审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/badBehaviorRevokeDetail',
      component: badBehaviorRevokeDetail,
      name: '不良行为撤销详情',
      meta: {
        right: [],
        name: '不良行为撤销详情',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/badBehaviorRevoke',
      component: badBehaviorRevoke,
      name: '不良行为撤销',
      meta: {
        right: [],
        name: '不良行为撤销',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/evaluationBadBehaviorInput',
      component: evaluationBadBehavior,
      name: '不良行为录入',
      meta: {
        right: [],
        name: '不良行为录入',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/revokeEvaluationInput',
      component: evaluationBadBehavior,
      name: '不良行为撤销',
      meta: {
        right: [],
        name: '不良行为撤销',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/evaluationBadBehavior',
      component: evaluationBadBehavior,
      name: '不良行为详情',
      meta: {
        right: [],
        name: '不良行为详情',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/revokeRvaluationBadBehavior',
      component: evaluationBadBehavior,
      name: '不良行为撤销',
      meta: {
        right: [],
        name: '不良行为撤销',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/evaluationBadBehaviorCheck',
      component: evaluationBadBehavior,
      name: '不良行为认定审核',
      meta: {
        right: [],
        name: '不良行为认定审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/evaluationBadBehaviorSupply',
      component: evaluationBadBehavior,
      name: '不良行为审核',
      meta: {
        right: [],
        name: '不良行为审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/badBehaviorCheck',
      component: badBehaviorCheck,
      name: '不良行为审核',
      meta: {
        right: [],
        name: '不良行为审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/noBadBehaviorDetails',
      component: badBehaviorDetail,
      name: '无不良行为详情',
      meta: {
        right: [],
        name: '无不良行为详情',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/revokeRvaluationBadBehaviorCheck',
      component: evaluationBadBehavior,
      name: '不良行为撤销审核',
      meta: {
        right: [],
        name: '不良行为撤销审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissApply',
      component: dismissApply,
      name: '申请解聘',
      meta: {
        right: [],
        name: '申请解聘',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissApplyInput',
      component: dismissApply,
      name: '解聘录入',
      meta: {
        right: [],
        name: '解聘录入',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissApplyCheck',
      component: dismissApply,
      name: '解聘审核',
      meta: {
        right: [],
        name: '解聘审核',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/dismissApplyDetail',
      component: dismissApply,
      name: '解聘详情',
      meta: {
        right: [],
        name: '解聘详情',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/expertWorkMge',
      component: workRecordIndex,
      name: '专家工作管理',
      meta: {
        right: [],
        name: '专家工作管理',
        isShowMenu: true,
        iszj: true,
        t:Date.now()
      },
      children: [
        {
          path: '/expertWorkRecord',
          component: expertWorkRecord,
          name: '评审专家工作记录',
          meta: {
            right: [],
            name: '评审专家工作记录',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        }, 
        {
          path: '/workRecordInput',
          component: workRecordDetail,
          name: '评审专家工作记录录入',
          meta: {
            right: [],
            name: '评审专家工作记录录入',
            isShowMenu: false,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/workRecordEdit',
          component: workRecordDetail,
          name: '评审专家工作记录编辑',
          meta: {
            right: [],
            name: '评审专家工作记录编辑',
            isShowMenu: false,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/workRecordDetail',
          component: workRecordDetail,
          name: '评审专家工作记录查看',
          meta: {
            right: [],
            name: '评审专家工作记录查看',
            isShowMenu: false,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/socialFeedBackList',
          component: socialFeedBackList,
          name: '社会反馈信息',
          meta: {
            right: [],
            name: '社会反馈信息',
            keepAlive: false,
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/socialFeedBackInput',
          component: socialFeedBackDetail,
          name: '社会反馈信息录入',
          meta: {
            right: [],
            name: '社会反馈信息录入',
            keepAlive: false,
            isShowMenu: false,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/socialFeedBackDetail',
          component: socialFeedBackDetail,
          name: '社会反馈信息查看',
          meta: {
            right: [],
            name: '社会反馈信息查看',
            keepAlive: false,
            isShowMenu: false,
            iszj: true,
            t:Date.now()
          },
        },
        {
          path: '/regularReviewList',
          component: regularReviewList,
          name: '评审专家定期审核',
          meta: {
            right: [],
            name: '评审专家定期审核',
            keepAlive: false,
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          }
        },
        {
          path: '/regularReviewDetail',
          component: regularReviewDetail,
          name: '定期审核',
          meta: {
            right: [],
            name: '定期审核',
            keepAlive: false,
            isShowMenu: false,
            t:Date.now()
          },
        },
        {
          path: '/feedbackSurveyList',
          component: feedbackSurveyList,
          name: '评标专家反馈调查表',
          meta: {
            right: [],
            name: '评标专家反馈调查表',
            isShowMenu: true,
            iszj: true,
            t:Date.now()
          },
        },
        
      ],
    },
    {
      path: '/feedbackSurveyPersonList',
      component: feedbackSurveyPersonList,
      name: '评标专家反馈调查表名单',
      meta: {
        right: [],
        name: '评标专家反馈调查表名单',
        isShowMenu: false,
        t:Date.now()
      },
    },
    {
      path: '/feedbackSurveyDetails',
      component: feedbackSurveyDetails,
      name: '专家评标反馈调查表详情',
      meta: {
        right: [],
        name: '专家评标反馈调查表详情',
        isShowMenu: false,
        t:Date.now()
      },
    },
  ],
};
export default examinelistRouter;
